import {ReactNode} from 'react';

import {PageHeaderTitle} from './page-header-title';

type PageHeaderProps = {
  children?: ReactNode;
  title: string;
};

export const PageHeader = ({title, children}: PageHeaderProps) => {
  return (
    <div className="flex items-center justify-between gap-4 mb-4 ">
      <PageHeaderTitle title={title} />
      {children}
    </div>
  );
};
